import { Component } from "react";

const commonTrackers = {
  trackAddToCart: ({ product, qty }) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "er_event_add_to_cart",
      ep: "ecommerce",
      ev: "add to cart",
      ecommerce: {
        currencyCode: "EUR",
        value: product.price,
        add: {
          products: [
            {
              id: product.sku,
              name: product.name,
              price: product.price,
              variant: product.variant,
              category: product.product_range,
              quantity: qty,
            },
          ],
        },
      },
    });
  },
  trackSiriusLink: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_link_click",
      ev: "retrouvez toute la gamme sirius",
      ecommerce: undefined,
    });
  },

  trackFromExternal: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_popin_show",
      ev: "popin information depuis site externe",
      ecommerce: undefined,
    });
  },

  trackNeedConnectPopin: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_popin_show",
      ev: "popin inscription ou connection",
      ecommerce: undefined,
    });
  },

  trackConnectionPopin: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_popin_show",
      ev: "popin connection",
      ecommerce: undefined,
    });
  },

  trackSubscriptionPopin: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_popin_show",
      ev: "popin inscription",
      ecommerce: undefined,
    });
  },

  trackRobertetLink: (e) => {
    e.preventDefault();
    window.open(e.target.href, "_blank");
  },

  trackRegisterOk: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_account_creation_success",
      ecommerce: undefined,
    });
  },

  trackRegisterKo: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_account_creation_error",
      ecommerce: undefined,
    });
  },

  trackGoToReviews: (e) => {
    window.location = e.target.href;
  },

  trackTabDownloads: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_product_tab_click",
      ev: "documents à télécharger",
    });
  },

  trackTabInformation: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_product_tab_click",
      ev: "description",
    });
  },

  trackTabTechnical: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "er_event",
      ep: "er_product_tab_click",
      ev: "informations techniques",
    });
  },

  trackCurrentTab(key, onload = false) {
    // If onload === true, it's hash and not a key so we remove #
    if (onload) {
      key = key.substring(1);
    }

    if (key === "reviews") {
      this.trackTabReviews();
    } else if (key === "documents") {
      this.trackTabDownloads();
    } else if (key === "description") {
      this.trackTabInformation();
    } else if (key === "technical-information") {
      this.trackTabTechnical();
    }
  },
};

class Tracker extends Component {
  componentDidMount() {
    this.trackPage();
  }

  trackPage() {
    const tracker = this.props.event;
    if (this.props.item) {
      commonTrackers[tracker](this.props.item);
    } else {
      commonTrackers[tracker]();
    }
  }

  render() {
    return null;
  }
}

export default commonTrackers;
export { Tracker };
